import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable()

export class HttpErrorHandler {

  constructor() { }

  public handleError(error: HttpErrorResponse) {
    console.log(error);
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.message;
    } else {
      // server-side error
      //**Localization - Need to fix
      errorMessage = $localize`We are experiencing technical difficulties. Please try again later or contact the Agency for assistance.`;
    }

    return throwError(errorMessage);
  }
}
